import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    accountTypeList: () => {
        return HTTP.get('/account/list_ac_type', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addAccountType: (data) => {
        return HTTP.post('/account/ac_type_create',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editAccountType: (id,data) => {
        return HTTP.post('/account/ac_type_update/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    changeStatusAccountType: (id) => {
        return HTTP.post('/account/ac_type_switch_status/'+id,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailAccountType: (id) => {
        return HTTP.get('/account/ac_type_edit/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}